// Export a constant whose value is a string

export const FETCH_HEADLINES = 'FETCH_HEADLINES';

export const FETCH_HEADLINES_REQUEST = 'FETCH_HEADLINES_REQUEST';
export const FETCH_HEADLINES_SUCCESS = 'FETCH_HEADLINES_SUCCESS';
export const FETCH_HEADLINES_FAILURE = 'FETCH_HEADLINES_FAILURE';